import { Container } from "./styles";
import ScrollAnimation from "react-animate-on-scroll";

const projects = [
  {
    year: "2023",
    title: "Discovery Kids India - Movie Launch",
    description: "Led a fully integrated movie launch campaign combining traditional marketing, digital strategy, and influencer-driven amplification. The promotional plan included kids’ events, platform-specific digital content, a collaboration network of kid-focused influencers, and a custom Snapchat AR filter designed to spark interactive engagement. This cross-channel approach created strong audience momentum and delivered a 67% increase in engagement across all social platforms, along with a highly positive campaign response.",
    metrics: ["🎯 Hybrid launch strategy: traditional + digital + influencers", "👧 Kids' events & offline activations", "👑 Snapchat AR filter for interactive promotion", "📈 67% platform-wide engagement growth", "🔥 Strong audience response & promotional traction"],
    tech: ["Campaign Strategy", "Digital Marketing", "Influencer Collaboration"]
  },
  {
    year: "2024",
    title: "House of Toys (Toys “R” Us - India Relaunch Campaign)",
    description: "A full-funnel relaunch strategy built around nostalgia, parent trust, and digital-first storytelling. From concept development to social execution - the campaign increased visibility, engagement, and organic traction across all platforms. Successfully positioned the brand for its re-entry into the Indian market with comprehensive digital presence.",
    metrics: ["✨ +35% brand visibility", "✨ +40% engagement", "✨ Strong nationwide digital traction"],
    tech: ["Campaign Strategy", "Digital Planning", "Content Direction"]
  },
  {
    year: "2022-2023",
    title: "Discovery Kids - YouTube Growth Strategy",
    description: "Redesigned the entire content funnel, metadata structure, and posting strategy - helping scale the channel from 10K to 5M subscribers while significantly improving content performance. The optimisation framework also contributed to a 40% increase in YouTube ad revenue, driven by better retention, higher watch-time, and stronger content alignment with audience behaviour.",
    metrics: ["🚀 10K → 5M subscribers", "📈 Improved retention & watch-time", "💰 40% increase in YouTube ad revenue", "🎬 Scaled kids' content formats for consistency & growth"],
    tech: ["SEO", "YouTube Content Strategy", "Audience Growth"]
  },
];

export function Project() {
  return (
    <Container id="projects">
      <h2>Featured Work</h2>
      <div className="projects">
        {projects.map((project, index) => (
          <ScrollAnimation animateIn="flipInX" key={index}>
            <div className="project">
              <header>
                <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#7C3AED" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                  <title>Campaign</title>
                  <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
                </svg>
              </header>
              <div className="body">
                <h3>{project.title} ({project.year})</h3>
                <p>{project.description}</p>
                {project.metrics && project.metrics.length > 0 && (
                  <div className="metrics">
                    <div className="metrics-title">Key Results</div>
                    <div className="metrics-grid">
                      {project.metrics.map((metric, i) => (
                        <div className="metric-card" key={i}>
                          <span className="metric-icon">✓</span>
                          <span className="metric-text">{metric}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              <footer>
                <ul className="tech-list">
                  {project.tech.map((tech, i) => (
                    <li key={i}>{tech}</li>
                  ))}
                </ul>
              </footer>
            </div>
          </ScrollAnimation>
        ))}
      </div>
    </Container>
  );
}
